import { useState } from "react";

import { Tooltip } from "@mui/material";

import "components/Screens/Marketplace/Customer/ProfileSection/ProfileContent.scss";

interface SoftwareSkill {
  name: string;
  imageUrl?: string;
}

interface SoftwareSkillsSectionProps {
  skills: string[] | SoftwareSkill[];
}

function SoftwareSkillsSection({ skills }: SoftwareSkillsSectionProps) {
  const [hoveredSkill, setHoveredSkill] = useState<string | null>(null);

  const isSkillObject = (skill: string | SoftwareSkill): skill is SoftwareSkill => {
    return typeof skill === "object" && skill !== null && "name" in skill;
  };

  const formattedSkills: SoftwareSkill[] = skills.map((skill) => {
    if (isSkillObject(skill)) {
      return skill;
    }
    return { name: skill };
  });

  return (
    <div id="software" className="profile-content__section">
      <div className="profile-content__title mb-075">Software Skills</div>
      <div className="software-skills__grid">
        {formattedSkills.map((skill) => (
          <Tooltip
            key={skill.name}
            title={skill.name}
            placement="top"
            arrow
            open={hoveredSkill === skill.name}
            disableHoverListener
          >
            <div
              className="software-skills__item"
              onMouseEnter={() => setHoveredSkill(skill.name)}
              onMouseLeave={() => setHoveredSkill(null)}
            >
              {skill.imageUrl ? (
                <div className="software-skills__image-container">
                  <img src={skill.imageUrl} alt={skill.name} className="software-skills__image" />
                </div>
              ) : (
                <div className="software-skills__name para-body-m-medium">{skill.name}</div>
              )}
            </div>
          </Tooltip>
        ))}
      </div>
    </div>
  );
}

export default SoftwareSkillsSection;
